import React, { useEffect, useState } from 'react';
import {connect} from 'react-redux'

import withErrorHandler from '../../hocs/withErrorHandler'
import axios from '../../httpClients/axios-datamerch'
import * as actions from '../../store/actions'

import { MembersTable } from '../../components/Account';
import { CircularProgress, Backdrop, Card, CardHeader, Divider } from '@mui/material';
import useClasses from '../../helpers/useClasses';

const styles = theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  },
  backdrop: {
    zIndex: '100'
  }
});

const Members = props => {
  const classes = useClasses(styles);
  
  const { 
    onFetchMembers,
    onAccountGrantApiAccess,
    onAccountRevokeApiAccess,
    onAccountArchive,
    accounts,
    token,
    loading,
    pagination
  } = props

  const [page, setPage] = useState(0)
  const [per_page, setPerPage] = useState(25)
  const [search, setSearch] = useState('')
  const [isFiltered, setIsFiltered] = useState(false)
  
  useEffect(() => {
    if (search) {
      setIsFiltered(true)
    }
    onFetchMembers(token);
  }, [onFetchMembers, token])

  const handlePageChange = (event, newPage) => {
    setPage(newPage)
  }

  const handlePerPageChange = (event) => {
    setPerPage(event.target.value)
  }

  const handleToggleApiAccessClick = (event, account) => {
    event.preventDefault();
    if (account.can_access_api) {
      onAccountRevokeApiAccess(token, account.resource_id)
    } else {
      onAccountGrantApiAccess(token, account.resource_id)
    }
  }

  const handleArchiveClick = (event, accountId) => {
    event.preventDefault();
    onAccountArchive(token, accountId)
  }

  const handleSearchClick = (event, search) => {
    setIsFiltered(true)
    setSearch(search)
  }

  const handleSearchCancelClick = (event) => {
    setIsFiltered(false)
    setSearch('')
  }

  let membersTable = (
    <Backdrop className={classes.backdrop} open={true}>
      <CircularProgress color="inherit" />
    </Backdrop>
  )
  if(!loading){
    membersTable = (
      <MembersTable
        accounts={accounts}
      />
    )
  }
  
  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <Card>
          <CardHeader
            title="Our Members"
          />
          <Divider />
          {membersTable}
        </Card>
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    accounts: state.account.accounts,
    loading: state.account.loading,
    token: state.auth.token,
    pagination: state.account.pagination
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onFetchMembers: (token) => dispatch(actions.fetchDatamerchMembers(token))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(Members, axios))